import { HotelFragmentFragment } from '../generated/types';

export default function useMergedHotelFeatures(data: HotelFragmentFragment) {
  const features = [];

  if (data.featuresForFrontend) {
    for (const feature of data.featuresForFrontend) {
      features.push(feature);
    }
  }

  if (data.highlightedFeaturesForFrontend) {
    for (const highlightedFeature of data.highlightedFeaturesForFrontend) {
      features.push(highlightedFeature);
    }
  }

  return features;
}
